import { render } from "./TechnologyCenter.vue?vue&type=template&id=5a84eb9a&scoped=true"
import script from "./TechnologyCenter.vue?vue&type=script&lang=js"
export * from "./TechnologyCenter.vue?vue&type=script&lang=js"

import "./TechnologyCenter.vue?vue&type=style&index=0&id=5a84eb9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a84eb9a"]])

export default __exports__